// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"cff19200","252":"1ce5cace","701":"bef410ae"}[chunkId] + ".css";
};